import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs';

import { environment } from '../../../environments/environment';

export interface AdminLoginResponse {
  token: string;
}

@Injectable({
  providedIn: 'root'
})
export class AdminAuthService {
  private readonly http = inject(HttpClient);
  private readonly tokenKey = 'arcaneLegion.adminToken';

  login(password: string) {
    return this.http
      .post<AdminLoginResponse>(`${environment.apiBaseUrl}/admin/login`, { password })
      .pipe(tap(response => this.setToken(response.token)));
  }

  logout(): void {
    if (!this.isBrowser()) {
      return;
    }

    window.localStorage.removeItem(this.tokenKey);
  }

  isLoggedIn(): boolean {
    return Boolean(this.getToken());
  }

  getToken(): string | null {
    if (!this.isBrowser()) {
      return null;
    }

    return window.localStorage.getItem(this.tokenKey);
  }

  private setToken(token: string): void {
    if (!this.isBrowser()) {
      return;
    }

    window.localStorage.setItem(this.tokenKey, token);
  }

  private isBrowser(): boolean {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  }
}
